import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setView } from '../../../store/actions/setting'
import { getKeyViewActive, getListViews } from '../../../store/selectors/selectors'
import { viewT } from '../../../utils/listView';
//@ts-ignore
import s from './OrientationView.module.scss'


export const OrientationView = () => {

    const listViews: viewT[] = useSelector(getListViews)
    const keyViewActive: string = useSelector(getKeyViewActive)

    const dispatch = useDispatch()

    const onSelectItem = (item: viewT) => {
        dispatch(setView(item['key']))
    }

    return (
        <div className={s.viewLine}>
            {listViews.map(item => {

                let isActive = item['key'] === keyViewActive;

                let viewItem = `${s.item}`
                if (isActive) viewItem += ` ${s.active}`

                return (<div className={viewItem} key={item['key']} onClick={() => onSelectItem(item)} >{item['name']}</div>)
            })}
        </div>
    )
}
